import { TestLog } from "../../test.log";
import { inject, Injectable } from "@angular/core";
import { GlossSyncService } from "../../gloss.sync.service";
import { UserStoreService } from "../../../store/user/user.store.service";
import { ImportStoreService } from "../../../store/import/import.store.service";
import { ConfirmationDialogService } from "../../../confirmation/confirmation.service";
import { TransactionStoreService } from "../../../store/transaction/transaction.store.service";
import { DataPluginStoreService } from "../../../store/data-plugin/data-plugin.store.service";
import { InstitutionService } from "../../../DataService/institution/institution.service";
import { AppStateStoreService } from "../../../store/app-state/app-state.store.service";
import { BasiqMapper } from "../mappers/basiq.mapper";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { DataRepositoryService } from "@bitwarden/web-vault/app/services/DataRepository/data-repository.service";
import { BasiqDataApi } from "@bitwarden/web-vault/app/services/syncing/basiq/api/basiq.api.data";
import DateFormat from "@bitwarden/web-vault/app/shared/utils/helper.date/date-format";
import { BasiqAuthApi } from "@bitwarden/web-vault/app/services/syncing/basiq/api/basiq.api.auth";

@Injectable({
  providedIn: "root",
})
export class BasiqActions {
  protected glossSyncService: GlossSyncService;
  protected userStore: UserStoreService;
  protected importStore: ImportStoreService;
  protected confirmationDialog: ConfirmationDialogService;
  protected transactionStore: TransactionStoreService;
  protected testLogService: TestLog;
  protected basiqDataApi: BasiqDataApi;
  protected basiqAuthApi: BasiqAuthApi;
  protected dataPluginStore: DataPluginStoreService;
  protected institutionService: InstitutionService;
  protected appState: AppStateStoreService;
  protected basiqMapper: BasiqMapper;
  protected dataRepositoryService: DataRepositoryService;
  protected dateFormat: DateFormat;
  constructor() {
    this.userStore = inject(UserStoreService);
    this.importStore = inject(ImportStoreService);
    this.confirmationDialog = inject(ConfirmationDialogService);
    this.testLogService = new TestLog(inject(LogService));
    this.transactionStore = inject(TransactionStoreService);
    this.basiqDataApi = inject(BasiqDataApi);
    this.dataPluginStore = inject(DataPluginStoreService);
    this.institutionService = inject(InstitutionService);
    this.glossSyncService = inject(GlossSyncService);
    this.appState = inject(AppStateStoreService);
    this.basiqMapper = inject(BasiqMapper);
    this.dataRepositoryService = inject(DataRepositoryService);
    this.dateFormat = inject(DateFormat);
    this.basiqAuthApi = inject(BasiqAuthApi);
  }
}
